import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'striphtml'
})

export class StripHtmlPipe implements PipeTransform {
  transform(value: string): any {
   
      //create a temp element to get innertext only
      const temp = document.createElement('div');
      temp.innerHTML = value;
      let text = temp.innerText || temp.textContent || '';
      // remove the temp element
      temp.remove();
      return text;
    
        
    }
}
